import React, { useEffect, useRef, useState } from 'react';
import { message, Select, Spin, Upload } from 'antd';
import { SDrawer, SGeneralForms } from 'shj-components';
import ImageUpload from '@/components/Upload/ImageUpload'
import {
    addExtAccountByExtEmpId,
    editExtAccount,
    findExtAccountById,
} from '@/services/externalPerson'
import {
    getBanksAreasList,
    getBanksList,
    getBanksLocationsList,
} from '@/services'
import { useFileUrlPrefix } from 'shj-utils';
import backBankCard from '@/assets/backBankCard.png';
import bankCardFront from '@/assets/bankCardFront.png';
import { getImgRelativePath } from '@/utils';

const addAndEdit = (props: any) => {
    const { Option } = Select;
    const formRef = useRef<any>()
    const fileUrlPrefix = useFileUrlPrefix()
    const { visibleDrawer = false, title = '新增/编辑', record, closeDetails, getDetail, id } = props
    const [loading, setLoading] = useState(false);
    const [spinLoading, setSpinLoading] = useState(false);
    const [bankNameList, setBankNameList] = useState<any>([])
    const [banksLocationsList, setBanksLocationsList] = useState<any>([])
    const [banksAreasList, setBanksAreasList] = useState<any>([])
    const [bankCode, setBankCode] = useState<any>('')
    const [areaCode, setAreaCode] = useState<any>('')
    useEffect(() => {
        if (visibleDrawer) {
            formRef.current?.onFormRef()?.resetFields();
            if (record.id) {
                findExtAccountById({id: record.id, labelFlag: true}).then(res =>{
                    res.imgFrontUrl = [{
                        name: res.imgFrontUrl,
                        url: fileUrlPrefix + res.imgFrontUrl,
                        relativePath: res.imgFrontUrl
                    }]
                    res.imgBackUrl = [{
                        name: res.imgBackUrl,
                        url: fileUrlPrefix + res.imgBackUrl,
                        relativePath: res.imgBackUrl
                    }]
                    formRef.current?.onFormRef()?.setFieldsValue({ ...res })
                })
            }
        }
    }, [visibleDrawer])

    const insertOrUpdateInfo = (formObj: any) => {
        if (formObj.id) {
            return editExtAccount(formObj)
        } else {
            return addExtAccountByExtEmpId(formObj)
        }
    }
    const onSubmit = (values) => {
        console.log(values)
        let formObj = {
            ...values,
            cityCode: areaCode,
            extEmpId: id,
            "imgFrontUrl": getImgRelativePath(values.imgFrontUrl[0]),
            "imgBackUrl": getImgRelativePath(values.imgBackUrl[0]),
            mainFlag: values.mainFlag ? true : false
        }
        setLoading(true)
        insertOrUpdateInfo(formObj).then((res) => {
            setLoading(false)
            message.success(res.message || "操作成功")

            getDetail()
            closeDetails()
        }
        ).catch(() => {
            setLoading(false)
        })
    };
    const getOptions = async (): Promise<any> => {
        return new Promise(async (resolve) => {
            const bankNameList = await getBanksList({ bankNameKeyword: '' });
            const banksAreasList = await getBanksAreasList({ areaNameKeyword: '' });
            const banksLocationsList = await getBanksLocationsList({ branchNameKeyword: '' });
            setBankNameList(bankNameList)
            setBanksAreasList(banksAreasList)
            setBanksLocationsList(banksLocationsList)
        });
    }
    const onSearchbankName = (value: string) => {
        getBanksList({ bankNameKeyword: value }).then((response: any) => {
            setBankNameList(response)
        });
    }
    const onSearchBanksAreas = (value: string) => {
        getBanksAreasList({ areaNameKeyword: value }).then((response: any) => {
            setBanksAreasList(response)
        });
    }
    const onSearchBanksLocations = (value: string, areaCode?: any) => {
        getBanksLocationsList({ areaCode, bankCode, branchNameKeyword: value }).then((response: any) => {
            setBanksLocationsList(response)
        });
    }
    const onSelectbankName = (_value, data) => {
        setBankCode(data?.key)
        setBanksLocationsList([])
    }
    const onSelectBanksAreas = (_value, data) => {
        setAreaCode(data?.key)
        onSearchBanksLocations('', data?.key)
    }
    const onSelectBankBranchName = (_value, data) => {
        const values = formRef.current?.onFormRef()?.getFieldsValue();
        values.bankBranchNumber = data?.dataId;
        values.bankBranchName = data?.key;
        formRef.current?.onFormRef()?.setFieldsValue({ ...values });
    }
    const beforeUpload = (file: any) => {
        if ((file.type || '').startsWith('image')) {
            if (!file.name.endsWith('.jpg') && !file.name.endsWith('.bmp') && !file.name.endsWith('.png') && !file.name.endsWith('.jpeg')) {
                message.error('图片必须是jpg/jpeg/png/bmp格式')
                return Upload.LIST_IGNORE
            }
            return true
        }
        message.error('只能上传图片')
        return Upload.LIST_IGNORE
    }
    return (
        <>
            <SDrawer
                width={800}
                title={title}
                open={visibleDrawer}
                onClose={closeDetails}
                onSubmit={onSubmit}
                loading={loading}
                destroyOnClose
            >
                <Spin spinning={spinLoading}>
                    <SGeneralForms
                        ref={formRef}
                        layout="vertical"
                        httpOptionsFn={getOptions}
                        configs={[
                            {
                                title: '银行卡信息',
                                titleMode: 'drawer',
                                formItem: [
                                    { name: 'id', hidden: true },
                                    { name: 'mainFlag', hidden: true },
                                    {
                                        name: 'imgFrontUrl',
                                        label: '银行卡正面',
                                        spanCol: 8,
                                        required: true,
                                        htmlFor: 'imgUrl',
                                        children: <ImageUpload exampleImgSrc={bankCardFront} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload} />,
                                    },
                                    {
                                        name: 'imgBackUrl',
                                        label: '银行卡背面',
                                        spanCol: 12,
                                        required: true,
                                        htmlFor: 'imgUrl',
                                        children: <ImageUpload exampleImgSrc={backBankCard} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload} />,
                                    },
                                    {
                                        name: 'idCard',
                                        label: '身份证号',
                                        required: true,
                                        spanCol: 12,
                                        maxLength: 20,
                                        comConfig: {
                                            disabled: record.mainFlag,
                                        }
                                    },
                                    {
                                        name: 'bankName', label: '银行名称', type: 'select', data: 'bankNameList', required: true, spanCol: 12,
                                        children: <Select showSearch={true} onSearch={onSearchbankName}
                                            onChange={onSelectbankName} placeholder={'请选择银行名称'}>
                                            {bankNameList.map((item: any) => (
                                                <Option key={item.bankCode} value={item.bankName}>
                                                    {item.bankName}
                                                </Option>
                                            ))}
                                        </Select>
                                    },
                                    {
                                        name: 'cityName', label: '所在城市', type: 'select', data: 'banksAreasList', required: true, spanCol: 12,
                                        children: <Select showSearch={true} onSearch={onSearchBanksAreas}
                                            onChange={onSelectBanksAreas} placeholder={'请选择所在城市'}>
                                            {banksAreasList.map((item: any) => (
                                                <Option key={item.areaCode} value={item.areaName}>
                                                    {item.areaName}
                                                </Option>
                                            ))}
                                        </Select>
                                    },
                                    {
                                        name: 'bankBranchName', label: '支行名称', type: 'select', data: 'banksLocationsList', required: true, spanCol: 12,
                                        children: <Select showSearch={true} onSearch={onSearchBanksLocations}
                                            onChange={onSelectBankBranchName}
                                            filterOption={false} // 禁用本地过滤
                                            notFoundContent={null} // 搜索时不显示"无匹配结果"
                                            placeholder={'请选择支行名称'}>
                                            {banksLocationsList.map((item: any) => (
                                                <Option key={item.branchName} value={item.branchCode} dataId={item.id}>
                                                    {item.branchName}
                                                </Option>
                                            ))}
                                        </Select>
                                    },
                                    {
                                        name: 'bankBranchNumber', label: '银行网点联行号', spanCol: 12, comConfig: {
                                            disabled: true,
                                        }
                                    },
                                    {
                                        name: 'openAccountName',
                                        label: '开户名',
                                        maxLength: 50,
                                        spanCol: 12,
                                        required: true,
                                    },
                                    {
                                        name: 'accountCode',
                                        label: '银行卡号',
                                        maxLength: 50,
                                        spanCol: 12,
                                        required: true,
                                    },
                                    { name: 'bankBranchCode', hidden: true },
                                    { name: 'bankBranchNumber', hidden: true },
                                    { name: 'censusRegisterAreaName', hidden: true }
                                ],
                            },
                        ]}
                    />
                </Spin>
            </SDrawer>
        </>
    );
};
export default addAndEdit
